import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { vars } from '../common'

const MenuItem = ({ text, onClick, index }) => (
  <MenuItemContainer aria-label={index === 0 ? `expanded ${text}` : null} autoFocus={index === 0} onClick={onClick} tabIndex="0" role="menuitem">{text}</MenuItemContainer>
)

MenuItem.propTypes = {
  text: PropTypes.string,
  onClick: PropTypes.func,
}

export default MenuItem


const MenuItemContainer = styled.button`
  flex: 1;
  background: none;
  padding: 10px 10px;
  cursor: pointer;
  min-height: 1em;
  color: var(--clr-black-to-text, #000);
  border: none;

  &:hover,
  &:focus {
    background: var(--clr-bot-main, ${vars.grey1});
    color: ${props => props.theme.secondaryColor};
  }
`



// WEBPACK FOOTER //
// ./src/ChatWidget/components/Menu/MenuItem.js